import request from '@/utils/request'
import { getToken, setToken, removeToken } from '@/utils/auth'
const user = {
  state: {
    Info: {
      username: '',
    },
    token: getToken(),
  },

  mutations: {
    SET_INFO(state, data) {
      state.Info = data
      if (data) {
        localStorage.setItem('userInfo', JSON.stringify(data))
      }
    },
    REMOVE_INFO(state) {
      state.Info = {
        id: '',
        avatar: '',
        email: '',
        gender: '',
        invite_code: '',
        invite_num: '',
        nickname: '',
        chain: '',
      }
      localStorage.removeItem('userInfo')
    },
    SET_TOKEN(state, data) {
      state.token = data
    },
    REMOVE_TOKEN(state) {
      state.token = null
      localStorage.removeItem('token')
    },
  },

  actions: {
    // 登录
    Login({ commit }, { type, data }) {
      return new Promise((resolve, reject) => {
        let path = null
        switch (type) {
          case 1:
            path = '/api/frontend/user/emailLogin'
            break
          case 2:
            path = '/api/frontend/user/phoneLogin'
            break
          case 3:
            path = '/api/frontend/user/phoneRegister'
            break
          case 4:
            path = '/api/frontend/user/emailRegister'
            break
          case 5:
            path = 'googlelogin'
            break
          case 6:
            path = 'tonlogin'
            break
        }
        request({
          url: path,
          method: 'post',
          data,
        })
          .then((res) => {
            console.log(res)
            if (res.code == 0) {
              if (type != 3 && type != 4) {
                setToken(res.data.token, data.keepLogin)
                commit('SET_INFO', { ...res.data.user })
                commit('SET_TOKEN', res.data.token)
              }

              resolve()
            } else {
              reject(res)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    // 获取用户信息
    GetInfo({ state, commit }, data) {
      return new Promise((resolve, reject) => {
        // if (state.Info.uuid && !data) {
        //   return resolve(state.Info)
        // }
        // if (JSON.parse(localStorage.getItem('userInfo')) && !data) {
        //   return resolve(JSON.parse(localStorage.getItem('userInfo')))
        // }
        if (state.token) {
          request({
            url: '/api/frontend/user/info',
            method: 'get',
          })
            .then((response) => {
              commit('SET_INFO', response.data)
              resolve(response.data)
            })
            .catch((error) => {
              reject(error)
            })
        } else {
          reject()
        }
      })
    },
    Statistics({ state, commit }, data) {
      console.log(data)
      return new Promise((resolve, reject) => {
        request({
          url: '/api/frontend/addViewLog',
          method: 'post',
          data: {
            type: data,
          },
        })
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            console.log(error)

            // reject(error)
          })
      })
    },
    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise((resolve) => {
        commit('REMOVE_INFO')
        commit('REMOVE_TOKEN')
        removeToken()
        if (window.coco) {
          window.coco.logout()
        }
        resolve()
      })
    },
  },
}

export default user
